<div class="integration-status-container">
    <scaffold-integration-banner *ngFor="let integration of integrations" [integration]="integration"></scaffold-integration-banner>
</div>

